import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductNameClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public put(hierarchyId: string, name: string): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ProductName/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, name: name }

    return AjaxWrapper.get<string, any>(url, data);
  }
}

